import { useLayoutEffect } from 'react';
import { useLocation } from 'react-router-dom';

const RouteScroller = () => {
    const { pathname, hash } = useLocation();

    useLayoutEffect(() => {
        // If there's a hash target, try to scroll to that element (poll until available).
        if (hash) {
            const id = hash.replace('#', '');
            let attempts = 0;
            const maxAttempts = 60; // ~1s at 60fps
            const tryScroll = () => {
                console.log('tryScroll() attempt', attempts);
                const el = document.getElementById(id);
                if (el) {
                    el.scrollIntoView({ behavior: 'smooth', block: 'start' });
                    return;
                }
                attempts += 1;
                if (attempts < maxAttempts) requestAnimationFrame(tryScroll);
            };
            requestAnimationFrame(tryScroll);
            return;
        }

        // Normal navigation (no hash) — scroll to top.
        window.scrollTo({ top: 0, left: 0, behavior: 'smooth' });
    }, [pathname, hash]);

    return null;
};

export default RouteScroller;
